import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { withFirebase } from '../Firebase';
import { withAuthorization } from '../Session';
import Countdown from '../Countdown/index';
import TrustBox from '../Trustpilot/index';
import cogoToast from 'cogo-toast';
import ReactGA from 'react-ga';
import { COLLECTIONS } from '../../constants/routes';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ReactPixel from 'react-facebook-pixel';
import Slider from "react-slick";
import * as ROUTES from '../../constants/routes';
// import { onAddToCart } from '../../helpers/global';

import './styles.scss';

const INITIAL_STATE = {
	error: null,
	loading: true,
	authUser: null,
	cart: []
};

const shippingOptionsObject = {
	'shippingStandard': 'Standard Shipping',
	'shippingExpedited': 'Expedited Shipping',
	'shippingSameDayDelivery': 'Same Day Delivery',
	'Free shipping': 'Free shipping',
	'Local pickup': 'Local pickup'
}

const sliderSettings = {
	dots: false,
	infinite: true,
	speed: 500,
	slidesToShow: 3,
	slidesToScroll: 2,
	arrows: true,
	centerMode: true,
	swipe: true,
	centerPadding: '50px',
	responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
    ]
};

class Cart extends Component {
	constructor(props) {
		super(props);
		this.state = { 
			...INITIAL_STATE,
			authUser: JSON.parse(localStorage.getItem('authUser')),
			settings: JSON.parse(localStorage.getItem('settings')),
			maxQty: 20,
			showCart: false,
		};
	}
	
	componentDidMount() {
		document.title = 'Cart';
		
		const { authUser, cart } = this.state;
		const self = this;

		this.mounted = true;
		
		if(authUser && cart){
			/* This will also be triggered when new items are added to or removed from cart  */
			self.unsubscribeCartItems = self.props.firebase.cartItems().doc(authUser.uid).onSnapshot(snapshot => {
				let updatedCart = []; /* Set empty array cart by default */
				
				if(snapshot.data() && Object.keys(snapshot.data()).length){
					/* Loop through list of cart item IDs  */
					Object.values(snapshot.data()).forEach(function (snapshotCart, index) {
						/* Query the items based on item ID */
						self.unsubscribeProduct = self.props.firebase.product(snapshotCart.id).onSnapshot(snapshotProduct => {
							/* If we receive a change on details of our product, we first check if it exists in our current cart state */
							let is_existing = updatedCart.find(item => snapshotProduct.id === item.id);
							if(is_existing){
								/* If existing, we find the position (index) of this item in our current cart state */
								let itemIndex = updatedCart.findIndex(item => snapshotProduct.id === item.id);
								/* Then we remove the item from the current cart state because we will append the updated item in our next code bellow (updatedCart.push())*/
								updatedCart.splice(itemIndex, 1); 
							}
							
							/* Append to cart array to reload entire cart item list */
							updatedCart.push({...snapshotCart, ...snapshotProduct.data()});
							self.setState({cart: updatedCart, loading: false}); /* !!!! setState is running multiple times here, figure out how to detect when child_added completed*/

						});
					});

					// ReactPixel.track('InitiateCheckout', {
					// 	content_ids: id,
					// 	content_name: product.name,
					// 	content_type: "product",
					// 	contents: product,
					// 	value: parseFloat(totalPrice).toFixed(2),
					// 	currency: 'GBP',
					// 	product_catalog_id: '2777510749188479',
					// });
					// console.log()
				} else {
					self.setState({cart: [], loading: false})
				}
			});

			
		} else {
			self.setState({ loading: false });
		}

		if (this.mounted) {
			this.loadProducts(false, true);
		}

		// console.log(this.state)
		
		ReactGA.ga('send', 'pageview', '/cart');
		
	}
	
	/* On unmount, we remove the listener to avoid memory leaks from using the same reference with the off() method: */
	componentWillUnmount() {
		this.unsubscribeCartItems();
		this.unsubscribeProduct && this.unsubscribeProduct();
		this.mounted = false;
	}
	
	onRemoveFromCart = id => {
		if(window.confirm('Are you sure you want to delete this product from your cart?')){
			const { authUser, cart } = this.state;
			
			let is_existing = Object.keys(cart).length && Object.values(cart).find(item => id === item.id); /* Check if item exists in cart from state */
			if(is_existing){
				let cartRef = this.props.firebase.cartItems();
				
				/* Get current cart contents */
				cartRef.doc(authUser.uid).get().then(snapshot => {
					let updatedCart = Object.values(snapshot.data()); /* Clone it first */
					let itemIndex = updatedCart.findIndex(item => id === item.id); /* Get the index of the item we want to delete */
					
					/* Remove item from the cloned cart state */
					updatedCart.splice(itemIndex, 1); 

					/* Set updated cart in firebase, no need to use setState because we already have a realtime cart listener in the componentDidMount() */
					cartRef.doc(authUser.uid).set(Object.assign({}, updatedCart)).then(() => {
						cogoToast.success("Removed from cart");
					});
				});
			}

			ReactGA.event({
				category: 'Cart',
				action: 'Click',
				label: 'Removed item'
			});

		}
	}
	
	onChangeQty = (event, id) => {
		event.persist(); /* Keep the original synthetic event around */
		
		const { authUser, cart } = this.state;
		
		let product = Object.keys(cart).length && Object.values(cart).find(item => id === item.id); /* Check if item exists in cart from state */
		
		if(product){
			// Check if user hits Max amount
			if (event.target.value > this.state.maxQty) {
				event.preventDefault();
				cogoToast.error(`Sorry, we've limited the entry to a maximum of ${this.state.maxQty} per person`);
				return;
			}
			if(event.target.value > product.stock){
				/* Do not allow save if user is trying to checkout more than what is available on stock */
				event.preventDefault();
				cogoToast.error("Insuficient stock");
				
			} else if(event.target.value <= 0){
				/* Do not allow save if user is trying to change to an invalid value */
				event.preventDefault();
				cogoToast.error("Invalid value, must be a positive number");
				
			} else {
				let cartRef = this.props.firebase.cartItems();
				
				/* Get current cart contents */
				cartRef.doc(authUser.uid).get().then(snapshot => {
					let updatedCart = Object.values(snapshot.data()); /* Clone it first */
					let itemIndex = updatedCart.findIndex(item => id === item.id); /* Get the index of the item we want to delete */
					
					/* Set item quantity */
					updatedCart[itemIndex]['quantity'] = event.target.value; 
					
					/* Set updated cart in firebase, no need to use setState because we already have a realtime cart listener in the componentDidMount() */
					cartRef.doc(authUser.uid).set(Object.assign({}, updatedCart)).then(() => {
						cogoToast.success("Quantity updated");
					});
				});
			}
		}
	}
	
	onChangeShippingOption = (event, id) => {
		event.persist(); /* Keep the original synthetic event around */
		
		/* Do not allow add to cart if option selected is not in list of available shipping options */
		if(event.target.value in shippingOptionsObject){
																		
			const { authUser, cart } = this.state;
			
			let productObject = Object.keys(cart).length && Object.values(cart).find(item => id === item.id); /* Check if item exists in cart from state */
			if(productObject){
				let cartRef = this.props.firebase.cartItems();
				
				/* Get current cart contents */
				cartRef.doc(authUser.uid).get().then(snapshot => {
					let updatedCart = Object.values(snapshot.data()); /* Clone it first */
					let itemIndex = updatedCart.findIndex(item => id === item.id); /* Get the index of the item we want to delete */
					
					/* Update item shipping type and value */
					updatedCart[itemIndex]['shippingType'] = event.target.value; 
					updatedCart[itemIndex]['shippingValue'] = productObject[event.target.value]; 
					
					/* Set updated cart in firebase, no need to use setState because we already have a realtime cart listener in the componentDidMount() */
					cartRef.doc(authUser.uid).set(Object.assign({}, updatedCart)).then(() => {
						cogoToast.success("Shipping option updated");
					});
				});
			}
		}
	}

	loadProducts(loadmore, fromComponent) {
		const { settings, lastItem, searchKeyword, searchCategory, searchFilter, searchEnabled, justAcitve, justEnded, showBadge } = this.state;
		const self = this;
		
		var pageLimit = settings && settings.perPageCollections ? parseInt(settings.perPageCollections) : 8;
		
		this.setState({ loadingBtn: true });
		
		/* Load first */
		var productQuery = this.props.firebase.products();
		
		// Only active comps
		// productQuery = productQuery.where('winnerChosen', '==', false).orderBy('stock');
		productQuery = productQuery.where('stock', '>', 0).orderBy('stock');

		// productQuery = productQuery.orderBy('highlight');
		productQuery.get().then(function(querySnapshot) {      
			self.setState({
				totalCount: querySnapshot.size ? querySnapshot.size : 0,
			});
		});
 
		productQuery.onSnapshot(snapshot => { /* The onSnapshot() method registers a continuous listener that triggers every time something has changed, use get() to only call it once (disable realtime) */
			let productChunk = [];
			
			snapshot.docChanges().forEach(function(change) {
				if (change.type === "added") {
					/* Add more items to the screen... */
					productChunk.push({ ...change.doc.data(), pid: change.doc.id });
				} else if (change.type === "modified") {
					/* If there is a change in realtime... */
					/* Apply the modification to the item directly without changing the current item index. */
					self.setState({
						products: self.state.products.map(el => (el.pid === change.doc.id ? {...change.doc.data(), pid: change.doc.id} : el)),
					});
				}

			});

			this.setState((prevState) => ({
				products: prevState.products && fromComponent ? [...prevState.products, ...productChunk]: productChunk,
				// loading: false,
				// loadingBtn: false,
				// lastItem: snapshot.docs[snapshot.docs.length - 1], 
				// showMoreBtn: productChunk.length < pageLimit ? false : true, 
			}));
			
		});


	}

	onAddToCart(productObject) {
		// console.log({productObject})
		// const { id, product, shippingType, quantity, discount } = productObject;
		const id = productObject.pid;
		const product = productObject;
		const quantity = 1;
		const discount = 0;
		const shippingType = 'Free'
		const { cart, authUser } = this.state;
		// console.log('on add to cart ', {
		// 	discount,
		// 	product,
		// 	quantity, 
		// });
		
		if(authUser){ 
			let is_existing = Object.keys(cart).length && Object.values(cart).find(item => id === item.id); /* Check if item already exists in cart from state */
			if(!is_existing){
				// let price = product.salePrice > 0 ? product.salePrice : product.price;
				// if (discount) {
				// 	console.log('price ', price);
				// 	console.log('discount ', discount);
				// 	let t = percentage(price, discount);
				// 	console.log(t);
				// 	price = price - (price * parseFloat(`.${discount}`));
				// 	console.log(price);
				// }
				let newItem = {
					'id': id, 
					'quantity': 1,
					'sellerID': product.author, 
					'purchasePrice': product.salePrice > 0 ? product.salePrice : product.price, 
					'discount': discount ? discount : 0,
					'shippingType': shippingType, 
					'shippingValue': product[shippingType] > 0 ? product[shippingType] : 0 /* Get shipping option value base on key */
				};
				let updatedCart = Object.values(cart); /* Clone it first */
				let cartRef = this.props.firebase.cartItems();
				
				/* Push new cart item */
				updatedCart.push(newItem); 
				
				/* Set updated cart in firebase, no need to use setState because we already have a realtime cart listener in the componentDidMount() */
				cartRef.doc(authUser.uid).set(Object.assign({}, updatedCart)).then(() => {
					cogoToast.success("Added to cart");
				});

				ReactGA.event({
					category: 'Add On',
					action: 'Click',
					label: `${product.name} for 1`,
				});

				
				let totalPrice = 0;
				let tempOgTotal = parseFloat(newItem.purchasePrice * newItem.quantity).toFixed(2);
				if (newItem.discount) {
					totalPrice = parseFloat(tempOgTotal / 100 * (100 - newItem.discount)).toFixed(2);
				} else {
					totalPrice = tempOgTotal;
				}

				let tempProd = product;
				tempProd.id = id;

				ReactPixel.track('AddToCart', {
					id: id,
					content_ids: [id],
					content_name: product.name,
					content_type: "product",
					// contents: tempProd,
					value: parseFloat(totalPrice).toFixed(2),
					currency: 'GBP',
					product_catalog_id: '2777510749188479',
				});

				
				// const updateCatologuItem = async () => {
				// 	let response = await fetch('https://graph.facebook.com/<API_VERSION>/2777510749188479/batch?requests=<REQUESTS>')
				// }

			}
			
		} else {
			this.props.history.push(ROUTES.SIGN_IN);
			cogoToast.info("Sign in or register to continue");
			
			ReactGA.event({
				category: 'Products',
				action: 'Click Add To Bag',
				label: `Logged out user clicked add to bag`
			});

		}
	}

	toggleCart() {
		const { showCart } = this.state;

		this.setState({
			showCart: showCart ? false : true,
		});
	}
	
	render() {
		const { error, loading, cart, settings, showCart, products } = this.state;
		function percentage(percent, total) {
			return ((percent/ 100) * total).toFixed(2)
		}

		const showDiscount = (total, discount) => {
			return total - percentage(discount, total);
		}
		
		const cartIds = cart.map((itm) => itm.id);

		let filteredProducts;
		if (products) {
			filteredProducts = products.filter((prod) => {
				if (!cartIds.includes(prod.pid)) {
					return prod;
				}
			});
		}
			
		return (
			<div style={{backgroundColor: "#f2f2f2"}} className="cart">
				{loading ? <div>Loading...</div> : 
					<React.Fragment>
						<nav className="navbar navbar-dark bg-blue">
							<span className="navbar-brand text-center d-block">My Cart</span>

							<Link className="back-link" to={COLLECTIONS} >
								<ArrowBackIosIcon />
								Back
							</Link>
						</nav>

						<div className="container-fluid py-3" className={showCart ? 'container-fluid py-3' : 'container-fluid py-3 cart-hide'}>
							<div className="toggleCart my-3 mb-4">
								<button className={showCart ? "btn-atb text-left btn-active" : "btn-atb text-left"} onClick={() => this.toggleCart()} >{showCart ? 'Hide Cart' : 'Show Cart'} ({cart.length}) <ArrowBackIosIcon /></button>
							</div>
							{/* {!showCart && 
							<div className="add-ons">
								something
							</div>} */}
							<div className="card mb-3">
								<div className="table-responsive bg-white card-body">
									<table className="table res-tbl">
										<thead className="text-left">
											<tr>
												<th scope="col">Competition</th>
												<th scope="col">Entries</th>
												<th scope="col">Closing Date</th>
												<th scope="col">Total</th>
												<th scope="col"></th>
											</tr>
										</thead>
										<tbody>
											{cart.length ? cart.map((product, index) => (
												<tr key={index}>
													<td data-label="Product" className="text-left">
														<Link to={{pathname: '/products/view/' + product.id}} className="d-block d-lg-flex">
															<div className="d-inline-block pr-2">
																<h5>{product.name}</h5>
															</div>
															<div className="mr-3 mb-2 mb-lg-0">
																<img src={`${product.featured_image ? product.featured_image : '/placeholder.jpg'}`} width="200" alt={product.name} />
															</div>
														</Link>
													</td>
													<td data-label="Quantity">
														{product.stock > 0 
															?
																<div>
																	{/* <input onChange={(event) => this.onChangeQty(event, product.id)} type="number" min="1" max={this.state.maxQty} defaultValue={product.quantity} className="form-control d-xl-inline-block d-inline-block mr-2 mb-2 mb-xl-0" style={{width: "100px"}} /> */}
																	<p className="d-inline">{product.quantity} x {product.quantity > 1 ? 'tickets' : 'ticket'}</p>
																	{/* <span className="text-success f-13">{product.stock} tickets left</span> <br />
																	<span className="text-success f-13">Max {this.state.maxQty}</span> */}
																</div>
															: 
																<span className="text-danger f-13">Out of stock</span>
														}
														
													</td>
													<td data-label="End Date"><Countdown date={product.endDate} showLabel={false} /></td>
													{/* <td data-label="Shipping">
														{product.shippingMethod === 'Shipping options' 
															?
																<select onChange={(event) => this.onChangeShippingOption(event, product.id)} defaultValue={product.shippingType} className="form-control" style={{maxWidth: '220px'}}>
																	{product.shippingStandard && 
																		<option value="shippingStandard">
																			+{settings && settings.currencySymbol} {product.shippingStandard * product.quantity} on {shippingOptionsObject['shippingStandard']}
																		</option>
																	}
																	{product.shippingExpedited && 
																		<option value="shippingExpedited">
																			+{settings && settings.currencySymbol} {product.shippingExpedited * product.quantity} on {shippingOptionsObject['shippingExpedited']}
																		</option>
																	}
																	{product.shippingSameDayDelivery && 
																		<option value="shippingSameDayDelivery">
																			+{settings && settings.currencySymbol} {product.shippingSameDayDelivery * product.quantity} on {shippingOptionsObject['shippingSameDayDelivery']}
																		</option>
																	}
																</select>
															: 
																<em>{product.shippingMethod}</em>
														}
													</td> */}
													<td data-label="Total">
													{settings && settings.currencySymbol}{product.discount ? parseFloat(showDiscount((product.purchasePrice * product.quantity) + (product.quantity * product.shippingValue), product.discount)).toFixed(2) : parseFloat((product.purchasePrice * product.quantity) + (product.quantity * product.shippingValue)).toFixed(2)}
															{product.discount ? <p className="discount">Was <span>{settings && settings.currencySymbol}{(product.purchasePrice * product.quantity) + (product.quantity * product.shippingValue)}</span> {product.discount}% Off</p> : ''}
													</td>
													
													<td data-label="Action"><button onClick={() => this.onRemoveFromCart(product.id)} className="btn btn-dark">Remove</button></td>
												</tr>
											)) : 
												<tr>
													<td>Cart is empty</td>
												</tr>
											}
										</tbody>
									</table>
									<table className="table res-tbl">
										<tbody>	
											<tr>
												<td className="col-xs-12 align-middle text-center py-3 px-2 freedel-banner" colSpan="2">
													<p>Free delivery for the winner</p>
													<TrustBox />
												</td>
											</tr>
											<tr>
												<td className="align-middle font-weight-bold d-none d-sm-block">Total</td>
												<td data-label="Cart Total" className="font-weight-bold">
													{settings && settings.currencySymbol + ' '} 
													{cart.length ? cart.reduce((sum, i) => (
														sum += showDiscount((i.quantity * i.purchasePrice) + (i.quantity * i.shippingValue), i.discount)
													), 0).toFixed(2) : 0}
												</td>
											</tr>
											<tr>
												<td className="text-center d-block px-1" colSpan="2">
													{cart.length > 0 &&
														<Link to="/checkout" onClick={
															ReactGA.event({
																category: 'Cart',
																action: 'Click',
																label: 'Proceed to Checkout'
															})
														} className="btn btn-atb rounded-0 mr-2 px-1 py-2 font-weight-bold mb-2 col-xs-12 col-sm-9 col-sm-offset-3 d-sm-inline-block">Proceed to checkout</Link>
													}
													<Link to="/" onClick={() => {
														ReactGA.event({
															category: 'Cart',
															action: 'Click',
															label: 'Continue Shopping'
														})
													}} className="btn cont-shopping rounded-0 px-4 py-2 font-weight-bold mb-2">Continue Shopping</Link>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							
							{filteredProducts && filteredProducts.length ? <div className="add-ons">
								<h2 className="my-4">Others you may like</h2>
								<Slider {...sliderSettings}>
								{filteredProducts.map((prod, key) => <div className="px-2" key={key}>
									<div className="card mb-3 add-on-prod p-3">
										<h4>{prod.name}</h4>
										<Link to={`products/view/${prod.pid}`}>
											<img src={prod.featured_image} alt={prod.name} />
										</Link>
										<button className="btn-atb" onClick={() => this.onAddToCart(prod)}>Add a £{prod.price} ticket</button>
									</div>
								</div>)}
								</Slider>
							</div> : ''}
						</div>
					</React.Fragment>
				}
				
				{error && <div>{error.message}</div>}
						
			</div>
		);
	}
}

const condition = authUser => !!authUser; // "!!authUser" is shorthand for: "authUser != null"

/* We use compose() because each higher order component bellow dont depend on each other
   so instead of doing:
		withRouter(withFirebase(Cart));
   we just organize it like bellow:
*/
const CartPage = compose(
	withAuthorization(condition),
	withRouter,
	withFirebase,
)(Cart);

export default CartPage;